import { render, staticRenderFns } from "./personalStatistics.vue?vue&type=template&id=77bcb0de&scoped=true&"
import script from "./personalStatistics.vue?vue&type=script&lang=js&"
export * from "./personalStatistics.vue?vue&type=script&lang=js&"
import style0 from "./personalStatistics.vue?vue&type=style&index=0&id=77bcb0de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bcb0de",
  null
  
)

export default component.exports